import React, { Component } from 'react';
import './Style.css';
import '../../../custom.css'
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';

export class RegisterCommunity extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPost: false,
            loading: false,
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            },
            model: {
                DocumentType: '',
                Identification: '',
                Password: '',
                ConfirmPassword: '',
                Code: '',
                Target: 'Register'
            },
            modelOtp: {
                Identification: '',
                Target: 'Register',
                DocumentType: ''
            }
        }
    }

    async sendOtp() {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(this.state.modelOtp)
        }

        if (!this.state.model.Identification || !this.state.model.DocumentType) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Los campos marcados con asterisco (*) son obligatorios',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        this.setState({ loading: true });

        const response = await fetch('OtpManage/SendOtp', request);

        this.setState({ loading: false });

        if (response.status == 200) {

            const data = await response.json();
            if (!data.isSuccess) {
                this.setState({
                    alert: {
                        Title: 'Error',
                        Body: data.message,
                        Type: 'alert-danger',
                        Show: true
                    }
                });
            } else {
                this.setState({
                    alert: {
                        Title: 'Éxito',
                        Body: 'Hemos enviado un correo y un mensaje de texto con el código OTP',
                        Type: 'alert-success',
                        Show: true
                    }
                });
            }

        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Usuario y/o contraseña inválidos.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async Send_OnClick() {

        var isPost = this.state.isPost;
        isPost = true;
        this.setState({ isPost })

        if (!this.state.model.Identification || !this.state.model.Password || !this.state.model.ConfirmPassword || !this.state.model.DocumentType || !this.state.model.Code) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Los campos marcados con asterisco (*) son obligatorios',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (this.state.model.Password != this.state.model.ConfirmPassword) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'La contraseña es diferente a la confirmación de la contraseña.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch('Users/Insert', request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            if (data.isSuccess) {
                this.setState({
                    alert: {
                        Title: 'Éxito',
                        Body: 'Usuario creado con correctamente.',
                        Type: 'alert-success',
                        Show: true
                    }
                });
                window.location.href = '/comunidad';
            } else {
                this.setState({
                    alert: {
                        Title: 'Error',
                        Body: data.message,
                        Type: 'alert-danger',
                        Show: true
                    }
                });
            }

        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Creando el usuario, inténtelo más tarde.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div className="wrapp-login row">
                <div className="col-lg-6">
                    <img src={require('../../../images/login.jpg')} className="w-100 p-0" />
                </div>
                <div className="col-lg-6">


                    <div className="form-register card">

                        <div className="text-center mb-5"><a href="/comunidad"><img src={require('../../../icon/LogoLife.png')} style={{ width: 60 }} /></a></div>

                        <div className="form-group">
                            {this.state.isPost && !this.state.model.DocumentType ? <span className="required">
                                *
                            </span> : null}
                            <label> Tipo de documento</label>
                            <select className="form-control" onChange={(e) => {

                                var model = this.state.model;
                                model.DocumentType = e.currentTarget.value;

                                var otpModel = this.state.modelOtp;
                                otpModel.DocumentType = e.currentTarget.value;

                                this.setState({ model: model, modelOtp: otpModel });
                            }}>
                                <option value="">Seleccione una opción</option>
                                <option value="Cédula">Cédula</option>
                                <option value="NIT">NIT</option>
                                <option value="Cédula de extranjería">Cédula de extranjería</option>
                            </select>


                        </div>

                        <div className="form-group">
                            {this.state.isPost && !this.state.model.Identification ? <span className="required">
                                *
                            </span> : null}
                            <label> Documento de identidad</label>
                            <input type="text" className="form-control p-10" autoComplete="off" onChange={(e) => {

                                var model = this.state.model;
                                model.Identification = e.currentTarget.value;

                                var otpModel = this.state.modelOtp;
                                otpModel.Identification = e.currentTarget.value;

                                this.setState({ model: model, modelOtp: otpModel });
                            }} />
                        </div>

                        <div className="form-group">
                            <input type="button" className="btn btn-outline-secondary" value="Enviar código OTP" disabled={!this.state.model.Identification || !this.state.model.DocumentType} onClick={() => {
                                this.sendOtp();
                            }} />
                        </div>

                        <div className="form-group">
                            {this.state.isPost && !this.state.model.Password ? <span className="required">
                                *
                            </span> : null}
                            <label>Contraseña</label>
                            <input type="password" className="form-control p-10" autoComplete="off" onChange={(e) => {
                                var model = this.state.model;
                                model.Password = e.currentTarget.value;

                                this.setState({ model: model });
                            }} />
                        </div>

                        <div className="form-group">
                            {this.state.isPost && !this.state.model.ConfirmPassword ? <span className="required">
                                *
                            </span> : null}
                            <label> Confirmar contraseña</label>
                            <input type="password" className="form-control p-10" autoComplete="off" onChange={(e) => {
                                var model = this.state.model;
                                model.ConfirmPassword = e.currentTarget.value;

                                this.setState({ model: model });
                            }} />
                        </div>

                        <div className="form-group">
                            {this.state.isPost && !this.state.model.CodeOtp ? <span className="required">
                                *
                            </span> : null}
                            <label> Código OTP</label>
                            <input type="text" className="form-control p-10" onChange={(e) => {
                                var model = this.state.model;
                                model.Code = e.currentTarget.value;

                                this.setState({ model: model });
                            }} />
                        </div>

                        <div className="form-group">
                            <a href="/comunidad">¡Iniciar sesión!</a>
                        </div>
                        <div className="form-group">
                            <a href="/">Ir a Life Medellín</a>
                        </div>
                        <div className="form-group">
                            <input type="button" value="Enviar" className="btn btn-primary w-100" onClick={(e) => { this.Send_OnClick() }} />
                        </div>
                    </div>
                </div>

                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }}/> : null}
                {this.state.loading ? <Loading /> : null}
            </div>
        );
    }
}
